<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='用户信息管理' label2="修改密码" url="/system/user/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form" :rules="rules">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-5 col-form-label">旧密码：</label>
            <div class="col-lg-3">
              <el-form-item prop="pwd">
                <el-input type="password" v-model="form.pwd"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-5 col-form-label">新密码：</label>
            <div class="col-lg-3">
              <el-form-item prop="newpwd"  :rules="[{ required:true, message: '内容不能为空', trigger: 'blur' },{ min: 1, max: 100, message: '长度不能超过100个字符'},{pattern:/(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/, message:'必须包含字母、数字、特殊字符，至少8个字符', trigger:'blur'}]">
                <el-input type="password" v-model="form.newpwd"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-5 col-form-label">确认密码：</label>
            <div class="col-lg-3">
              <el-form-item prop="surepwd" >
                <el-input type="password" v-model="form.surepwd"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center;">
                  <SaveButton :url="saveUrl" back="/system/user/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChangePwd',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        } else {
          callback();
        }
      }
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          callback();
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入确认密码'));
        } else if (value !== this.form.newpwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
      return {
        form: {
          id: '',
          pwd: '',
          newpwd: '',
          surepwd: '',
          token: ''
        },
        rules: {
          pwd: [
            { validator: validatePass, trigger: 'blur' }
          ],
          newpwd: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          surepwd: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
        saveUrl: this.$utils.Url.system + '/systemapi/user/changepwd'
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .col-lg-1 {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
